/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_GInputs */

const en_tut_santai_g = /** @type {(inputs: Tut_Santai_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short breaks taken together are why people keep the office open. All of it is optional and only applies to people currently in the same room.`)
};

const id_tut_santai_g = /** @type {(inputs: Tut_Santai_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeda pendek yang dilakukan bersama adalah alasan orang betah membuka kantor. Semuanya opsional dan hanya berlaku untuk yang sedang berada di ruang yang sama.`)
};

/**
* | output |
* | --- |
* | "Short breaks taken together are why people keep the office open. All of it is optional and only applies to people currently in the same room." |
*
* @param {Tut_Santai_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_g = /** @type {((inputs?: Tut_Santai_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_g(inputs)
	return en_tut_santai_g(inputs)
});